import { useEffect, type FC } from "react";
import { useScroll } from "../../../contexts/useScroll";
import LogoIcon from "../../../components/icons/LogoIcon";
import { Slot, Templated } from "../../../templating";

const ChatMessageListLoader: FC = () => {
  const { scrollToBottom } = useScroll();

  useEffect(() => {
    // `setTimeout` used to ensure DOM is updated before scroll attempt
    setTimeout(scrollToBottom, 0);
  }, [scrollToBottom]);

  return (
    <Templated id="lastbot-typing-indicator">
      <div className="flex gap-x-4" data-testid={`bot-thinking`}>
        <div className="shrink-0">
          <LogoIcon />
        </div>
        <div>
          <Slot name="label">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 32" fill="currentColor" className="h-8 w-[22px] text-lastbot-on-surface-soft">
              <circle cx="3" cy="16" r="2" className="animate-jump animation-delay-0" />
              <circle cx="11" cy="16" r="2" className="animate-jump animation-delay-200" />
              <circle cx="19" cy="16" r="2" className="animate-jump animation-delay-400" />
            </svg>
          </Slot>
        </div>
      </div>
    </Templated>
  );
};

export default ChatMessageListLoader;
